import { CRMUser, ExecutiveBriefingProfile } from '../types';

export interface ExecutiveBriefingOption {
  uid: string;
  name: string;
  email: string;
  profile: ExecutiveBriefingProfile;
  /** Briefing-only — no exec inbox / Gmail funnel. */
  briefingOnly: boolean;
}

function isBriefingEnabled(u: CRMUser): boolean {
  return u.executiveBriefing?.enabled === true || u.execInbox?.enabled === true;
}

function resolveProfile(u: CRMUser): ExecutiveBriefingProfile {
  if (u.executiveBriefing?.enabled && u.executiveBriefing.profile === 'coo') return 'coo';
  if (u.executiveBriefing?.profile === 'ceo') return 'ceo';
  if (u.execInbox?.enabled) return 'ceo';
  return u.executiveBriefing?.enabled ? 'coo' : 'ceo';
}

/** Executives whose day briefing the caller may open. */
export function listAccessibleExecutives(
  crmUsers: CRMUser[],
  callerUid: string,
  callerIsAdmin: boolean,
): ExecutiveBriefingOption[] {
  const out: ExecutiveBriefingOption[] = [];
  for (const u of crmUsers) {
    if (!isBriefingEnabled(u)) continue;
    const viewers = u.executiveBriefing?.viewers || [];
    const delegates = u.execInbox?.delegates || [];
    const canAccess =
      u.uid === callerUid
      || callerIsAdmin
      || viewers.includes(callerUid)
      || delegates.includes(callerUid);
    if (!canAccess) continue;
    out.push({
      uid: u.uid,
      name: u.displayName || u.email,
      email: u.email,
      profile: resolveProfile(u),
      briefingOnly: u.executiveBriefing?.enabled === true && !u.execInbox?.enabled,
    });
  }
  out.sort((a, b) => {
    if (a.uid === callerUid) return -1;
    if (b.uid === callerUid) return 1;
    return a.name.localeCompare(b.name);
  });
  return out;
}

export function profileBriefingTitle(profile: ExecutiveBriefingProfile): string {
  return profile === 'coo' ? 'COO day briefing' : 'Day briefing';
}

export function profileLabel(profile: ExecutiveBriefingProfile): string {
  return profile === 'coo' ? 'COO' : 'CEO';
}
